import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Calendar, momentLocalizer } from 'react-big-calendar'
import { GetCalendarEvents } from './CalendarSlice';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from "moment";
import 'moment/locale/nb';
import './Calendar.css';
import Confetti from 'react-confetti'
var Holidays = require('date-holidays')
var hd = new Holidays('NO');

moment.locale("nb");
const localizer2 = momentLocalizer(moment);

function Event({ event }) {
    if (event.resource === 'Jenny') {
        return (
            <span className="jenny2_ikkebruk">
                <img src="/images/Jenny.png" style={{ width: "30px" }}></img> {event.title}
            </span>)
    }
    else if (event.resource === 'Sivert') {
        return (
            <span className="sivert2_ikkebruk">
                <img src="/images/Sivert.png" style={{ width: "30px" }}></img> {event.title}
            </span>)
    }

    else if (event.resource === 'Bursdager') {
        return (
            <span className="birtday2_ikkebruk">
                <Confetti
                    width={400}
                    height={38}
                    numberOfPieces={80}
                />
                <i className="fa fa-birthday-cake" aria-hidden="true"></i> {event.title}
            </span>)
    }
    else if (event.resource === 'Espen') {
        return (
            <span className="espen2_ikkebruk">
                <img src="/images/Espen.png" style={{ width: "30px" }}></img> {event.title}
            </span>)
    }
    else if (event.resource === 'Britt') {
        return (
            <span className="britt2_ikkebruk">
                <img src="/images/britt.jfif" style={{ width: "30px" }}></img> {event.title}
            </span>)
    }
    return (
        <span>{event.title}
            {/* <img src="/images/Jenny.png" style={{ width: "30px" }}></img> {event.title} */}
        </span>
    )
}

function EventAgenda({ event }) {
    if (event.allDay === true) {
        return (
            <span className="allday">
                <em style={{ color: 'magenta' }}>{event.title}</em>
                <p>{event.desc}</p>
            </span>
        )
    }

    return (
        <span>
            <em style={{ color: 'magenta' }}>{event.title}</em>
            <p>{event.desc}</p>
        </span>
    )
}

const CalendarWrapper = ({
    events,
    isLoading,
    GetCalendarEvents
}) => {

    const [view, setView] = useState("week");
    const [date, setNewDate] = useState(new Date());

    useEffect(() => {
        GetCalendarEvents();
    }, []);

    function increaseDate() {
        var newDate;
        if (isMonthView() || isAgendaView()) {
            newDate = new Date(date.getFullYear(), date.getMonth() + 1, date.getDate());
        }
        else if (isWeekView()) {
            newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 7);
        }
        else if (isDayView()) {
            newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
        }
        setNewDate(newDate);
    }

    function decreaseDate() {
        var newDate;
        if (isMonthView() || isAgendaView()) {
            newDate = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
        }
        else if (isWeekView()) {
            newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 7);
        }
        else if (isDayView()) {
            newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
        }
        setNewDate(newDate);
    }

    function isWeekView() {
        return view === "week";
    }

    function isMonthView() {
        return view === "month";
    }

    function isDayView() {
        return view === "day";
    }

    function isAgendaView() {
        return view === "agenda";
    }

    function getDateLabel() {
        if (isMonthView()) {
            return date.toLocaleString('no-nb', { month: 'long', year: 'numeric' });
        }
        else if (isWeekView()) {
            var momentDate = moment(date);
            return `Uke ${momentDate.week()}: ${momentDate.startOf("week").format('D MMMM')} - ${momentDate.endOf("week").format('D MMMM')}`;

            // return date.toLocaleString('no-nb', { weekday: 'long', day: 'numeric', month: 'long' });
        }
        else if (isDayView()) {
            return date.toLocaleString('no-nb', { weekday: 'long', day: 'numeric', month: 'long' });
        }
    }

    return (

        <div className={isLoading ? "calendar filtering" : "calendar"}>
            <div className="calendarHeader">
                <div className="calendarHeaderLeft">
                    <button className="calendarButonNavigation" title="Måned" onClick={() => setView("month")}><i className="fas fa-calendar-alt"></i></button>
                    <button className="calendarButonNavigation" title="Uke" onClick={() => setView("week")}><i className="fas fa-calendar-week"></i></button>
                    <button className="calendarButonNavigation" title="Dag" onClick={() => setView("day")}><i className="fas fa-calendar-day"></i></button>
                    {/* <button onClick={() => setView("agenda")}><i class="fas fa-list-alt"></i></button> */}
                </div>
                <div className="calendarHeaderCenter">
                    <span>{getDateLabel()}</span>
                </div>
                <div className="calendarHeaderRight">
                    <button className="calendarButonNavigation" onClick={() => setNewDate(new Date())}><i className="far fa-calendar-check"></i></button>
                    <button className="calendarButonNavigation" onClick={() => decreaseDate(new Date())}><i className="far fa-calendar-minus"></i></button>
                    <button className="calendarButonNavigation" onClick={() => increaseDate(new Date())}><i className="far fa-calendar-plus"></i></button>
                </div>
            </div>

            <Calendar
                localizer={localizer2}
                events={events}
                startAccessor="start"
                endAccessor="end"
                // style={{ width: "100%" }}
                defaultView="week"
                view={view}
                // defaultDate={new Date(2020,1,1)}
                defaultDate={new Date()}
                date={date}
                timeslots={1}
                step={120}
                min={new Date(1970, 1, 1, 7, 0)}
                toolbar={false}
                selectable={false}
                components={{
                    event: Event,
                    agenda: {
                        event: EventAgenda,
                    },
                }}
                eventPropGetter={(event, start, end, isSelected) => {
                    var classes = "calendarItem";
                    if (event.allDay === true) { classes = classes + " allDayItem"; }
                    else { classes = classes + " shortItem"; }

                    if (event.resource === 'Sivert') { classes = classes + " sivert" }
                    else if (event.resource === 'Jenny') { classes = classes + " jenny" }
                    else if (event.resource === 'Bursdager') { classes = classes + " birthday" }
                    else if (event.resource === 'Espen') { classes = classes + " espen" }
                    else if (event.resource === 'Britt') { classes = classes + " britt" }
                    return { className: classes };
                }}
                dayPropGetter={(date) => {
                    var day = date.getDay();
                    var isWeekend = (day === 6) || (day === 0);
                    var isHoliday = hd.isHoliday(date);
                    if (isHoliday && isHoliday.type === 'public') { return { className: "holiday" } }
                    if (isWeekend) { return { className: "weekend" } }
                    return { className: "" };
                }}
                onSelectEvent={(event, e) => {

                    console.log(event);
                }
                }
            />
            <span className="calendarSpinner" style={{ display: isLoading ? 'inline-block' : 'none' }}></span>
        </div>

    );
}


const mapDispatchToProps = { GetCalendarEvents };

const mapStateToProps = (state) => ({
    events: state.calendar.events,
    isLoading: state.calendar.isLoading,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CalendarWrapper);